"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addMetadataWithoutDuplicates = addMetadataWithoutDuplicates;
function addMetadataWithoutDuplicates(a, b) {
    a = { ...(a ?? {}) };
    for (const [key, value] of Object.entries(b ?? {})) {
        if (a[key] === undefined) {
            a[key] = value;
        }
        else if (a[key] !== value) {
            for (let i = 0; i < 10; i++) {
                const newKey = `${key}${i + 1}`;
                if (a[newKey] === undefined) {
                    a[newKey] = value;
                    break;
                }
            }
        }
    }
    return a;
}
//# sourceMappingURL=addMetadataWithoutDuplicates.js.map